import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { StorageConstants } from '../../../shared/constants/storage.constants';
import { UrlConstants } from '../../../shared/constants/urlparams.constants';

import { GameService } from '../../../shared/services/game.service';
import { MessageService } from '../../../shared/services/message.service';

@Injectable()
export class JoinGameGuard implements CanActivate {
  constructor(private router: Router, private gameService: GameService, private messageService: MessageService) { }

  redirectToRegister(gameID: string, gameName: string) {
    return this.router.parseUrl("game/" + gameID + "/" + gameName + "/joinGame");
  }

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    let gameID = route.paramMap.get(UrlConstants.GameID);
    let gameName = route.paramMap.get(UrlConstants.GameName);
    let playerName = localStorage.getItem(StorageConstants.PlayerName);

    if (!this.gameService.isConnected()) {
      return this.redirectToRegister(gameID, gameName);
    }

    if (playerName == "" || playerName.length > 16) {
      this.messageService.showWarning("U heeft nog geen naam, voer een naam in");
      return false;
    }

    return true;
  }
}
